import { AlertTriangleIconSvg } from "../../assets/icons/AlertTriangleIconSvg";
import CategoryIconSvg from "../../assets/icons/categoryIcon/CategoryIconSvg";
import { CollectionsIconSvg } from "../../assets/icons/Collections/CollectionsIconSvg";
import { DashboardIconSvg } from "../../assets/icons/DashboardIconSvg";
import { LayersIconSvg } from "../../assets/icons/LayersIconSvg";
import LicenseIconSvg from "../../assets/icons/licenseIcon/LicenseIconSvg";
import { MessageIconSvg } from "../../assets/icons/MessageIconSvg";
import PagesIconSvg from "../../assets/icons/pagesIcon/PagesIconSvg";
import ScreenIconSvg from "../../assets/icons/screenIcons/ScreenIconSvg";
import { SettingIconSvg } from "../../assets/icons/SettingIcon/SettingIconSvg";
import { FaqIconSvg } from "../../assets/icons/studioIcons/FaqIconSvg";
import { FeaturedProjectsIconSvg } from "../../assets/icons/studioIcons/FeaturedProjectsIconSvg";
import { PricingIconSvg } from "../../assets/icons/studioIcons/PricingIconSvg";
import { TestimonialIconSvg } from "../../assets/icons/studioIcons/TestimonialIconSvg";

export const mainNavigation: any = [
  {
    text: "Dashboard",
    module: "DASHBOARD",
    icon: <DashboardIconSvg color="rgba(255, 255, 255, 0.5)" />,
    iconSelected: <DashboardIconSvg color="white" />,
    to: "/",
  },
  {
    text: "Components",
    module: "PRODUCTS",
    icon: <CollectionsIconSvg color="rgba(255, 255, 255, 0.5)" />,
    iconSelected: <CollectionsIconSvg color="white" />,
    to: "/product",
  },
  {
    text: "Pages",
    module: "PAGES",
    icon: <PagesIconSvg color="rgba(255, 255, 255, 0.5)" />,
    iconSelected: <PagesIconSvg color="white" />,
    to: "/page",
  },
  {
    text: "Screens",
    module: "SCREENS",
    icon: <ScreenIconSvg color="rgba(255, 255, 255, 0.5)" />,
    iconSelected: <ScreenIconSvg color="white" />,
    to: "/screen",
  },
  {
    text: "Collections",
    module: "COLLECTIONS",
    icon: <LayersIconSvg color="rgba(255, 255, 255, 0.5)" />,
    iconSelected: <LayersIconSvg color="white" />,
    to: "/collections",
  },
  {
    text: "Reports",
    module: "REPORTS",
    icon: <AlertTriangleIconSvg color="rgba(255, 255, 255, 0.5)" />,
    iconSelected: <AlertTriangleIconSvg color="white" />,
    to: "/reports",
  },
  {
    text: "Feedbacks",
    module: "FEEDBACKS",
    icon: <MessageIconSvg color="rgba(255, 255, 255, 0.5)" />,
    iconSelected: <MessageIconSvg color="white" />,
    to: "/feedbacks",
  },
  {
    text: "Studio Settings",
    module: "STUDIO_SETTINGS",
    icon: <SettingIconSvg color="rgba(255, 255, 255, 0.5)" />,
    iconSelected: <SettingIconSvg color="white" />,
    // to: "/studio-settings",
    subNavigations: [
      {
        text: "Testimonials",
        module: "STUDIO_TESTIMONIALS",
        icon: <TestimonialIconSvg color="rgba(255, 255, 255, 0.5)" />,
        iconSelected: <TestimonialIconSvg color="white" />,
        to: "/studio-settings/testimonials",
      },
      {
        text: "Featured Projects",
        module: "STUDIO_FEATURED_PROJECTS",
        icon: <FeaturedProjectsIconSvg color="rgba(255, 255, 255, 0.5)" />,
        iconSelected: <FeaturedProjectsIconSvg color="white" />,
        to: "/studio-settings/featured-projects",
      },
      {
        text: "Pricing",
        module: "STUDIO_PRICING",
        icon: <PricingIconSvg color="rgba(255, 255, 255, 0.5)" />,
        iconSelected: <PricingIconSvg color="white" />,
        to: "/studio-settings/pricing",
      },
      {
        text: "FAQs",
        module: "STUDIO_FAQS",
        icon: <FaqIconSvg color="rgba(255, 255, 255, 0.5)" />,
        iconSelected: <FaqIconSvg color="white" />,
        to: "/studio-settings/faqs",
      },
    ],
  },
  {
    text: "Settings",
    module: "SETTING",
    icon: <SettingIconSvg color="rgba(255, 255, 255, 0.5)" />,
    iconSelected: <SettingIconSvg color="white" />,
    to: "/settings",
  },
];

export const FiltersPopupNavigation: any = [
  {
    text: "Categories",
    module: "CATEGORIES",
    icon: <CategoryIconSvg color="rgba(255, 255, 255, 0.5)" />,
    iconSelected: <CategoryIconSvg color="white" />,
  },
  {
    text: "Collections",
    module: "COLLECTIONS",
    icon: <CollectionsIconSvg color="rgba(255, 255, 255, 0.5)" />,
    iconSelected: <CollectionsIconSvg color="white" />,
  },
  {
    text: "License",
    module: "LICENSES",
    icon: <LicenseIconSvg color="rgba(255, 255, 255, 0.5)" />,
    iconSelected: <LicenseIconSvg color="white" />,
  },
];
